import { Collection, RefString } from "@tblabs/truffle";
import { Field } from "../Description/Field";
import { Product } from "../Product/Product";
import { Tab } from "../Product/Tab";
import { ProductCategory } from "../Product/ProductCategory";
import { BasketConfig } from "../../Services/Basket/BasketConfig";
import { Faq } from "../Description/Faq/Faq";


export class ShopContent
{
    public Id = "Shop";
    public Logo = new RefString();
    public AboutUsText = new RefString();
    public AboutUsFaq = new Collection<Faq>();
    public ProductCategories = new Collection<ProductCategory>();
    public Products = new Collection<Product>();
    public get AvailableProducts(): Product[]
    {
        return this.Products.Items.filter(x => x.Visible.value);
    }
    public BasketOptions = new BasketConfig();
    public ContactTabs = new Collection<Tab>();
    public Contact = new Collection<Field>();
    public RentalPageContentTabs = new Collection<Tab>();
    public RentalPageContent = new Collection<Field>();

    public PrepareProducts(): void
    {
        // Set Category for each product
        this.Products.Items.forEach(product =>
        {
            const category = this.ProductCategories.Items.find(x => x.Id.value == product.CategoryId.value)

            product.Category = category ?? ProductCategory.NotFound();
        });
    }
}
